export const getTypeFromVariation = (variation) => {
	switch (variation) {
		case 'child':
			return 'child-screening';
		case 'youth':
			return 'youth-screening';
		case 'adult':
			return 'adult-screening';
		default:
			return 'adult-screening';
	}
};
